import { render, staticRenderFns } from "./FeedbackEsc4Act4.vue?vue&type=template&id=7baf1d6d&"
var script = {}
import style0 from "./FeedbackEsc4Act4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports